import React, { useCallback, useMemo, useState } from "react";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { initBookmark, paymentTypeTabs } from "@icoach/accountBook/staticData";
import { parseDate } from "@util/moment";
import { TabsCardLayout } from "@icoach/components";
import {
	getAccountBookOrderExpensesForRemitRowLabel,
	getAccountBookOrderIncomeForOnSiteRowLabel,
	getAccountBookOrderIncomeForRemitRowLabel,
	getAccountBookOrderRefundForOnSiteRowLabel,
	getAccountBookOrderRefundForRemitRowLabel,
} from "@icoach/accountBook/components/AccountBookOrderStatTemplate";
import PageLayout from "@icoach/components/layout/PageLayout";
import useTabState from "@util/hook/useTabState";
import { paymentMethodMap } from "@icoach/accountBook/staticData";
import { formatCurrencyFn, isEmpty, isEqual } from "@util/utils";
import { CounterBox } from "@icoach/members/components";
import { TransactionList } from "@icoach/accountBook/components";

const TransactionListDialog = ({ open, onClose, sourceData }) => {
	const { statisticsDate, filterType, paymentMethod = "on_site" } = sourceData;
	const { activeTab, handleTabChange: setInternalActiveTab } = useTabState(paymentTypeTabs.income);
	const [itemTotalList, setItemTotalList] = useState([]);

	const handleTabChange = (event, newValue) => {
		setInternalActiveTab(event, newValue);
	};

	const handleItemTotalList = useCallback(
		_itemTotalList => {
			if (!isEqual(_itemTotalList, itemTotalList)) {
				setItemTotalList(_itemTotalList);
			}
		},
		// eslint-disable-next-line
		[]
	);

	const tabsMap = useMemo(
		() => {
			return {
				[paymentMethodMap.onSite]: [
					{
						label: "收入",
						value: paymentTypeTabs.income,
					},
					{
						label: "退費",
						value: paymentTypeTabs.refund,
					},
				],
				[paymentMethodMap.remit]: [
					{
						label: "匯款收入",
						value: paymentTypeTabs.incomeByRemit,
					},
					{
						label: "匯款支出",
						value: paymentTypeTabs.expensesByRemit,
					},
					{
						label: "匯款退費",
						value: paymentTypeTabs.refundByRemit,
					},
				],
				[paymentMethodMap.all]: [
					{
						label: "收入",
						value: paymentTypeTabs.income,
					},
					{
						label: "退費",
						value: paymentTypeTabs.refund,
					},
					{
						label: "匯款收入",
						value: paymentTypeTabs.incomeByRemit,
					},
					{
						label: "匯款支出",
						value: paymentTypeTabs.expensesByRemit,
					},
					{
						label: "匯款退費",
						value: paymentTypeTabs.refundByRemit,
					},
				],
			};
		},
		// eslint-disable-next-line
		[]
	);

	const currentTab = useMemo(
		() => tabsMap[paymentMethod],
		// eslint-disable-next-line
		[]
	);

	const listDataMap = useMemo(
		() => {
			return {
				[paymentTypeTabs.income]: {
					desc: "現場收入",
					headerRow: getAccountBookOrderIncomeForOnSiteRowLabel(),
					sumKeys: ["cashPrice", "cardPrice", "totalPrice"],
				},
				[paymentTypeTabs.refund]: {
					desc: "現場退費",
					headerRow: getAccountBookOrderRefundForOnSiteRowLabel(),
					sumKeys: ["returnAmount"],
				},
				[paymentTypeTabs.incomeByRemit]: {
					desc: "匯款收入",
					headerRow: getAccountBookOrderIncomeForRemitRowLabel(),
					sumKeys: ["handingFee", "totalPrice"],
				},
				[paymentTypeTabs.expensesByRemit]: {
					desc: "匯款支出",
					headerRow: getAccountBookOrderExpensesForRemitRowLabel(),
					sumKeys: ["handingFee", "totalPrice"],
				},
				[paymentTypeTabs.refundByRemit]: {
					desc: "匯款退費",
					headerRow: getAccountBookOrderRefundForRemitRowLabel(),
					sumKeys: ["handingFee", "returnAmount"],
				},
			};
		},
		// eslint-disable-next-line
		[]
	);

	if (!open) return null;

	return (
		<Dialog className={"simple-content dialog"} open={open} fullScreen>
			<GradientColorHeader onClose={onClose}>收入清單</GradientColorHeader>
			<DialogContent className="bg-light p-0">
				<PageLayout>
					<TabsCardLayout tabs={currentTab} activeTab={activeTab} tabsContent={{ className: "px-3 pb-4" }} onTabChange={handleTabChange}>
						{!isEmpty(itemTotalList) && (
							<Grid className="mt-2" spacing={3} container>
								{itemTotalList.map(item => {
									return (
										<Grid key={item.orderType} xs={2} item>
											<CounterBox
												className="text-left"
												title={item.orderTypeText}
												counter={formatCurrencyFn(item.totalPrice, {
													symbol: "$",
												})}
											/>
										</Grid>
									);
								})}
							</Grid>
						)}
						<TransactionList
							{...listDataMap[activeTab]}
							defaultSearchParams={{
								...initBookmark(),
								date: parseDate(statisticsDate),
								filterType,
								statisticsType: activeTab,
							}}
							setItemTotalList={handleItemTotalList}
						/>
					</TabsCardLayout>
				</PageLayout>
			</DialogContent>
		</Dialog>
	);
};

export default TransactionListDialog;
